module.exports = kolibriGlobal.coreVue.components.GenderDisplayText;